import Navigation from '../Components/Navigation/Navigation';
import Header from '../Components/Header/Header';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React, { useState } from 'react';
import Footer from '../Components/Footer/Footer';
import About from '../Pages/About';
import Dashboard from '../Pages/Dashboard';
import HouseOfArieOne from '../Pages/HouseOfArieOne';
import Contact from '../Pages/Contact';
import HouseOfArieTwo from '../Pages/HouseOfArieTwo';

const Layout = () => {
  const [showNav, setShowNav] = useState(false);

  return (
    <Router>
      <Navigation
        show={showNav}
        setShowNav={setShowNav}
      />
      <Header
        setShowNav={setShowNav}
      />
      <Routes>
        <Route path='/about' element={<About />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/house-of-arie-one' element={<HouseOfArieOne />} />
        <Route path='/house-of-arie-two' element={<HouseOfArieTwo />} />
        <Route path='/' element={<Dashboard />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default Layout;
